import {Component}       from '@angular/core';
import {Router} from '@angular/router';
import {DataTableDirectives} from 'angular2-datatable/datatable';
import {FORM_DIRECTIVES, FORM_PROVIDERS, REACTIVE_FORM_DIRECTIVES, FormControl, FormGroup} from '@angular/forms';
import {AlertComponent} from 'ng2-bootstrap/ng2-bootstrap';
import {MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from 'ng2-bootstrap/ng2-bootstrap';
import {PaginatePipe, PaginationControlsCmp, PaginationService} from 'ng2-pagination';

import {VehicleBrandService}     from '../../service/vehicleBrand.service';
import {VehicleBrand} from '../../domain/vehicleBrand';
import {Page} from '../../domain/page';

@Component({
    selector: 'config-vehicleBrands',
    template: require('./config.vehicleBrands.component.html'),
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ConfigVehicleBrandsComponent {

    private data:VehicleBrand[];

    private filter:string;

    public error:any;

    private currentPage:Page;

    public form:FormGroup;

    public itemsPerPage:number;
    public loading:boolean;
    public page:number;
    public total:number;

    public vehicleBrandSelected:VehicleBrand;

    constructor(private router:Router,
                private vehicleBrandService:VehicleBrandService) {
        this.init();

        this.form.valueChanges
            .debounceTime(400)
            .subscribe(this.find.bind(this));

        this.find();
    }

    private init():void {
        this.data = [];

        this.filter = "";

        this.form = new FormGroup({
            search: new FormControl(),
            itemsPerPage: new FormControl()
        });

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;
    }

    public find():void {
        this.getData(1);
    }

    private getData(page:number):void {
        this.error = null;
        this.loading = true;
        this.vehicleBrandService.findVehicleBrands(this.filter, page, this.itemsPerPage).subscribe(
            (data) => {
                this.refreshData(data);
                this.page = page;
            },
            () => {
                this.bindError('Ocurrió un error al buscar las marcas.');
            });
    }

    private refreshData(page:Page):void {
        this.data = page.content.map(vehicleBrand => new VehicleBrand(vehicleBrand));
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public remove(deleteModal:any):void {
        this.error = null;
        this.vehicleBrandService.delete(this.vehicleBrandSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeFromView(this.vehicleBrandSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar la marca.');
            });
    }

    private removeFromView(vehicleBrand:VehicleBrand):void {
        let index = this.data.indexOf(vehicleBrand);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.vehicleBrandSelected = null;
    }

    public edit(vehicleBrand:VehicleBrand):void {
        this.router.navigate(['app/home/config/editVehicleBrand', vehicleBrand.id]);
    }

    public create():void {
        this.router.navigate(['app/home/config/createVehicleBrand']);
    }

    public getPage(page:number):void {
        this.getData(page);
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/config/vehicleBrands/config.vehicleBrands.component.ts
 **/